var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-title"},[_vm._v("Assinatura Eletrônica de Documentos")]),_c('assinaturaEletronica')],1)}
var staticRenderFns = []

export { render, staticRenderFns }